import { FC, useEffect } from "react";
import { AIFormInput, AISelect, AIText, useForm } from "aio-input";
import { I_ettelaateKhodro } from "../types";
import { useFreelancer } from "../context";
import Icon from "@mdi/react";
import { mdiCalendar } from "@mdi/js";

const EttelaateKhodro: FC<{
    data: I_ettelaateKhodro,
    onChange: (v: I_ettelaateKhodro) => void,
    setDisabled: (v: boolean) => void
}> = (props) => {
    const { options } = useFreelancer()
    const getPelakError = (data:I_ettelaateKhodro):string | undefined=>{
        const error = 'پلاک صحیح نیست'
        if(!data.pelak || !data.pelak.length){return error}
        if(data.noeVasileNaghlie === 0){
            if(!data.pelak[0] || !data.pelak[1]){return error}
        }
        else {
            if(data.pelak.length !== 4){return error}
            if(!data.pelak[0] || !data.pelak[1] || !data.pelak[2] || !data.pelak[3]){return error}
        }
    }
    const form = useForm<I_ettelaateKhodro>({
        initData: props.data, fa: true, inlineLabel: true,
        onChange: (data) => {
            props.onChange(data);
            props.setDisabled(form.isSubmitDisabled())
        },
        isRequired: (row, field) => {
            return field !== 'modeleVasileNaghlie'
        },
        getLayout: (context) => {
            const rowCls = 'p-v-12- gap-16-'
            const data = context.getData()
            const {noeVasileNaghlie} = data
            return {
                className: 'gap-16-',
                v: [
                    {
                        className: rowCls,
                        h: [
                            {
                                flex: 1,
                                input: {
                                    label: 'نوع وسیله نقلیه', field: 'noeVasileNaghlie', type: 'select', required: true,
                                    options: options.vehicleTypes.map((o: any) => ({ text: o.value, value: o.key })),
                                    popover: { fitHorizontal: true }
                                }
                            },
                            {
                                flex: 1,
                                input: {
                                    label: 'مدل وسیله نقلیه', field: 'modeleVasileNaghlie', type: 'select', required: true,
                                    options: options.vehicleMakes.map((o: any) => ({ text: o.value, value: o.key })), search: 'جستجو',
                                    popover: { fitHorizontal: true }
                                }
                            },
                            {
                                flex:1,
                                html:(
                                    <AIFormInput
                                        label={'پلاک'} required={true} inlineLabel={true}
                                        error={getPelakError(data)}
                                        input={
                                            <Plate key={noeVasileNaghlie} type={noeVasileNaghlie === 0?"motor_cycle":"car"} value={context.getData().pelak || []} onChange={(pelak) => context.changeData({ ...context.getData(), pelak })} />
                                        }
                                    />
                                )
                            },
                            
                            { flex: 1, input: { label: 'شماره VIN', type: 'text', field: 'vin', required: true } }
                        ]
                    },
                    {
                        className: rowCls,
                        h: [
                            { 
                                flex: 1,
                                input: {
                                    label: 'تاریخ اعتبار بیمه نامه', field: 'tarikheEtebareBimeName', type: 'date', jalali: true,size:16,
                                    after: <Icon path={mdiCalendar} size={0.8} color='#555' />, caret: false, placeholder: ' '
                                } 
                            },
                            { flex: 1, html: '' },
                            { flex: 1, html: '' },
                            { flex: 1, html: '' },
                        ]
                    }
                ]
            }
        }
    })
    useEffect(() => {
        const res = form.errors.getErrorsList()
        props.setDisabled(!!res.length)
    }, [])

    return <>{form.renderLayout}</>
}
export default EttelaateKhodro

export const ettelaateKhodroLayout = (context: any) => {
    const { options } = context;
    const rowCls = 'p-v-12- gap-16-'
    return {
        className: 'gap-16-',
        v: [
            {
                className: rowCls,
                h: [
                    {
                        flex: 1,
                        input: {
                            label: 'نوع وسیله نقلیه', field: 'noeVasileNaghlie', type: 'select', required: true,
                            options: options.vehicleTypes.map((o: any) => ({ text: o.value, value: o.key })),
                            popover: { fitHorizontal: true }
                        }
                    },
                    {
                        flex: 1,
                        input: {
                            label: 'مدل وسیله نقلیه', field: 'modeleVasileNaghlie', type: 'select', required: true,
                            options: options.vehicleMakes.map((o: any) => ({ text: o.value, value: o.key })), search: 'جستجو',
                            popover: { fitHorizontal: true }
                        }
                    },
                    {
                        flex: 1, html: (
                            <div className="msf">
                                <Plate type='car' label={'پلاک *'} value={context.getData().pelak || []} onChange={(pelak) => context.changeData({ ...context.getData(), pelak })} />
                            </div>
                        )
                    },
                    { flex: 1, input: { label: 'شماره VIN', type: 'text', field: 'vin', required: true } }
                ]
            },
            {
                className: rowCls,
                h: [
                    { flex: 1, input: { label: 'تاریخ اعتبار بیمه نامه', field: 'tarikheEtebareBimeName', type: 'date', jalali: true } },
                    { flex: 1, html: '' },
                    { flex: 1, html: '' },
                    { flex: 1, html: '' },
                ]
            }
        ]
    }
}


const Plate: FC<{ type: 'motor_cycle' | 'car', value: string[], onChange: (v: string[]) => void, label?: string }> = ({ type, value, onChange, label }) => {
    const change = (v: string, index: number) => {
        const newValue = []
        for (let i = 0; i < 4; i++) {
            if (index === i) {
                newValue.push(v)
            }
            else {
                newValue.push(value[i] || '')
            }
        }
        onChange(newValue)
    }
    return (
        <div className="aio-input-plate" key={type}>
            {!!label && <div className="aio-input-plate-label">{label}</div>}
            {
                type === 'car' &&
                <>
                    <div className="aio-input-plate-item" style={{width:48}}>
                        <AIText maxLength={2} filter={['number']} value={value[0]} onChange={(v) => change(v, 0)} />
                    </div>
                    <div className="aio-input-plate-item">
                        <AISelect
                            options={['الف', 'ب', 'ت', 'ج', 'ح', 'د', 'ر', 'ز', 'ژ', 'س', 'ص', 'ط', 'ع', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه']}
                            option={{ text: 'option', value: 'option' }} value={value[1]} onChange={(v) => change(v, 1)}
                        />
                    </div>
                    <div className="aio-input-plate-item">
                        <AIText maxLength={3} filter={['number']} value={value[2]} onChange={(v) => change(v, 2)} />
                    </div>
                    <div className="aio-input-plate-item">
                        <AIText maxLength={2} filter={['number']} value={value[3]} onChange={(v) => change(v, 3)} />
                    </div>
                </>
            }
            {
                type === 'motor_cycle' &&
                <>
                    <div className="aio-input-plate-item">
                        <AIText maxLength={3} filter={['number']} value={value[0]} onChange={(v) => change(v, 0)} />
                    </div>
                    <div className="aio-input-plate-item">
                        <AIText maxLength={5} filter={['number']} value={value[1]} onChange={(v) => change(v, 1)} />
                    </div>
                </>
            }
        </div>
    )
}